module.exports = __webpack_public_path__ + "static/hero1-3d2e737787481dd1a05745a951f09635.jpeg";